import { render, staticRenderFns } from "./AddSubCategory.vue?vue&type=template&id=48b9851d&"
import script from "./AddSubCategory.vue?vue&type=script&lang=ts&"
export * from "./AddSubCategory.vue?vue&type=script&lang=ts&"
import style0 from "./AddSubCategory.vue?vue&type=style&index=0&id=48b9851d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports